module.exports = __webpack_public_path__ + "static/assets/37c7c07e5a9a1fb2676ce8d865e63aef.png";